module.exports = __webpack_public_path__ + "img/6.5fa9861e.jpg";